import React, { useState } from 'react';
import { Button } from '../components/Button';
import { PhoneIcon, MailIcon, MapPinIcon, CalendarIcon, ShieldCheckIcon } from 'lucide-react';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Dummy submission
    alert('Thank you for your message. We will be in touch shortly.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <div className="flex flex-col w-full bg-cream min-h-screen" data-id="element-127">
      {/* Main Content Area - Header integrated into layout */}
      <section className="py-16 md:py-24" data-id="element-128">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-129">
          {/* Integrated Header */}
          <div className="mb-12 md:mb-16 max-w-3xl" data-id="element-130">
            <div className="w-1.5 bg-accent h-12 mb-6 rounded-full" data-id="element-131"></div>
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-primary mb-6" data-id="element-132">
              Get in Touch
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed" data-id="element-133">
              Take the first step toward feeling like yourself again. Whether
              you're ready to schedule your telehealth appointment or just have
              a few questions about how our process works, our team is ready to
              assist you.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start" data-id="element-134">
            {/* Left Panel: Info Card (Spans full height) */}
            <div className="lg:col-span-4 bg-primary rounded-2xl p-8 md:p-10 text-white shadow-xl lg:sticky lg:top-28" data-id="element-135">
              <h2 className="font-heading text-3xl font-bold mb-8 text-accent" data-id="element-136">
                We're Here to Help
              </h2>

              <div className="space-y-10" data-id="element-137">
                <div className="flex items-start" data-id="element-138">
                  <div className="flex-shrink-0 mt-1" data-id="element-139">
                    <PhoneIcon className="h-6 w-6 text-accent" data-id="element-140" />
                  </div>
                  <div className="ml-4" data-id="element-141">
                    <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-142">
                      Phone
                    </h3>
                    <p className="text-xl font-medium" data-id="element-143">[PHONE]</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-144">
                  <div className="flex-shrink-0 mt-1" data-id="element-145">
                    <MailIcon className="h-6 w-6 text-accent" data-id="element-146" />
                  </div>
                  <div className="ml-4" data-id="element-147">
                    <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-148">
                      Email
                    </h3>
                    <p className="text-xl font-medium" data-id="element-149">[EMAIL]</p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-150">
                  <div className="flex-shrink-0 mt-1" data-id="element-151">
                    <MapPinIcon className="h-6 w-6 text-accent" data-id="element-152" />
                  </div>
                  <div className="ml-4" data-id="element-153">
                    <h3 className="text-sm font-bold text-slate-400 uppercase tracking-wider mb-1" data-id="element-154">
                      Telehealth Service Area
                    </h3>
                    <p className="text-xl font-medium" data-id="element-155">
                      Serving patients in [STATE]
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Panel: Booking & Form */}
            <div className="lg:col-span-8 space-y-12" data-id="element-156">
              {/* Dummy Booking Widget */}
              <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-8 md:p-10" data-id="element-157">
                <div className="flex items-center justify-between mb-8" data-id="element-158">
                  <h2 className="font-heading text-3xl font-bold text-primary" data-id="element-159">
                    Schedule your tele-health appointment
                  </h2>
                  <CalendarIcon className="h-8 w-8 text-stone-300 hidden sm:block" data-id="element-160" />
                </div>

                <div className="bg-stone-50 border-2 border-dashed border-stone-200 rounded-xl p-8 text-center" data-id="element-161">
                  <p className="text-sm text-stone-500 font-bold mb-6 uppercase tracking-widest" data-id="element-162">
                    Sample telehealth booking widget — replace with real
                    scheduling tool
                  </p>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-4" data-id="element-163">
                    {['9:00 AM', '10:30 AM', '1:00 PM', '2:30 PM', '4:00 PM', 'More Times'].map((time, i) => <div key={i} className="bg-white border border-stone-200 rounded-lg py-3 text-sm text-stone-600 font-medium cursor-not-allowed opacity-70 shadow-sm" data-id="element-164">
                        {time}
                      </div>)}
                  </div>
                </div>
              </div>

              {/* Divider */}
              <div className="flex items-center justify-center" data-id="element-165">
                <div className="h-px bg-stone-300 flex-grow" data-id="element-166"></div>
                <span className="px-6 text-sm font-bold text-stone-400 uppercase tracking-widest bg-cream" data-id="element-167">
                  Or send us a message
                </span>
                <div className="h-px bg-stone-300 flex-grow" data-id="element-168"></div>
              </div>

              {/* Contact Form */}
              <div className="bg-white rounded-2xl shadow-md border border-gray-100 p-8 md:p-10" data-id="element-169">
                <h2 className="font-heading text-3xl font-bold text-primary mb-8" data-id="element-170">
                  Send a Message
                </h2>
                <form onSubmit={handleSubmit} className="space-y-6" data-id="element-171">
                  <div data-id="element-172">
                    <label htmlFor="name" className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide" data-id="element-173">
                      Name
                    </label>
                    <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-5 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all bg-stone-50 focus:bg-white" data-id="element-174" />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-175">
                    <div data-id="element-176">
                      <label htmlFor="email" className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide" data-id="element-177">
                        Email
                      </label>
                      <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-5 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all bg-stone-50 focus:bg-white" data-id="element-178" />
                    </div>
                    <div data-id="element-179">
                      <label htmlFor="phone" className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide" data-id="element-180">
                        Phone
                      </label>
                      <input type="tel" id="phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-5 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all bg-stone-50 focus:bg-white" data-id="element-181" />
                    </div>
                  </div>
                  <div data-id="element-182">
                    <label htmlFor="message" className="block text-sm font-bold text-gray-700 mb-2 uppercase tracking-wide" data-id="element-183">
                      How can we help?
                    </label>
                    <textarea id="message" name="message" rows={5} required value={formData.message} onChange={handleChange} className="w-full px-5 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all bg-stone-50 focus:bg-white resize-none" data-id="element-184"></textarea>
                  </div>

                  <div className="bg-orange-50 border-l-4 border-accent p-5 rounded-r-lg" data-id="element-185">
                    <p className="text-sm text-orange-900 leading-relaxed" data-id="element-186">
                      <strong data-id="element-187">Please note:</strong> Please don't share medical
                      details or test results here. We'll send you a secure link
                      for medical questions and intake forms.
                    </p>
                  </div>

                  <Button type="submit" variant="primary" className="w-full py-4 text-lg mt-4" data-id="element-188">
                    Send Message
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Reassurance Callout Bar */}
      <section className="bg-stone-100 border-t border-stone-200 py-8 mt-auto" data-id="element-189">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-190">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center sm:text-left gap-4" data-id="element-191">
            <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-192">
              <ShieldCheckIcon className="h-6 w-6 text-primary" data-id="element-193" />
            </div>
            <p className="text-stone-600 font-medium text-lg" data-id="element-194">
              After you contact us, we'll guide you to our secure telehealth
              system to complete medical forms and manage your care.
            </p>
          </div>
        </div>
      </section>
    </div>;
}